import React from 'react';

import { capitalizeFirstLetter } from '../blocks/utils/general-utils';
import ConditionalWrapper from './ConditionalWrapper';

/**
 * Breadcrumbs
 *
 * A DWT reusable component
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {string} props.postTitle
 * @param {boolean} props.seriesPost
 */
const Breadcrumbs = React.forwardRef( ({ context, postTitle, seriesPost }, breadcrumbsRef ) => {
  const path = document.location.pathname;
  const booksLanding = path.replaceAll( '/', '' ) === 'books';
  const imprintPostTitle = localStorage.getItem( 'imprintPostTitle' );

  return (
    <ul className='breadcrumbs__list flex items-center list-none gap-10 p-0 ml-0' ref={ breadcrumbsRef }>
      <ConditionalWrapper
        condition={ !booksLanding }
        wrapper={ () => <li className='breadcrumbs__list-item mb-0'><a className='breadcrumbs__link' href={ `/${context.featureBy.toLowerCase()}` }>{ capitalizeFirstLetter( context.featureBy ) }</a></li> }
      >
        <li className='breadcrumbs__list-item mb-0'>{ postTitle }</li>
      </ConditionalWrapper>

      { seriesPost && document.referrer.includes( 'imprint' ) && (
        <>
          <span>&rsaquo;</span>
          <ConditionalWrapper
            condition={ !booksLanding }
            wrapper={ () => <li className='breadcrumbs__list-item mb-0'><a className='breadcrumbs__link' href={ document.referrer }><span dangerouslySetInnerHTML={ { __html: imprintPostTitle } }></span></a></li> }
          />
        </>
      ) }

      { !booksLanding && (
        <>
          <span>&rsaquo;</span>
          <li className='breadcrumbs__list-item mb-0'>{ postTitle }</li>
        </>
      ) }
    </ul>
  );
});

export default Breadcrumbs;
